import React from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';

import PendingNavDataLoader from './nav-loader';
import Header from '../header';
import Lightbox from '../lightbox';

import './app.css';

const App = ({ location, route }) => (
  <PendingNavDataLoader location={location} routes={route.routes}>
    <Header />
    <main className="content">
      {renderRoutes(route.routes)}
    </main>
    <Lightbox />
  </PendingNavDataLoader>
);

App.propTypes = {
  location: PropTypes.object.isRequired,
  route: PropTypes.object.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/components/app/index.jsx